import '../plugins/Craft';
import { WhiteInstantSearchBuilder, mappers, MenuPanel } from '@white-nl/instantsearch-components';

import './src/containers/SearchBar';
import './src/containers/Partners';

declare global {
  interface Window {
    whiteInstantSearchSearchBar: WhiteInstantSearchBuilder;
    whiteInstantSearchPartners: WhiteInstantSearchBuilder;
    whiteInstantSearchMappers: typeof mappers;
    whiteInstantSearchMenuPanel: typeof MenuPanel;
  }
}

window.whiteInstantSearchMappers = mappers;
window.whiteInstantSearchMenuPanel = MenuPanel;
